// Native blocking: mask blocked author content with a user-facing notice
import classNames from 'classnames';
import { type PropsWithChildren, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Button } from '../../../../front/src/components/Button/Button';
import type { UserReport } from '../../../../front/src/types/api';
import { reportMessages } from './messages';

type ReportedContentBannerProps = PropsWithChildren<{
  createdAt: UserReport['createdAt'];
  className?: string;
}>;

const reportedButtonMessages = defineMessages({
  showAnyway: {
    defaultMessage: 'Display anyway',
    id: 'q9XsfI',
  },
  hide: {
    defaultMessage: 'Hide',
    id: 'VA/Z1S',
  },
});

export const ReportedContentBanner = ({
  createdAt,
  children,
  className,
}: ReportedContentBannerProps) => {
  const [hidden, setHidden] = useState(true);
  return (
    <div
      className={classNames(
        'ReportedContentBanner border border-gray-200 rounded-md bg-gray-50 p-3',
        className,
      )}
    >
      <p className="text-sm text-gray-600 flex items-between justify-between">
        <FormattedMessage
          {...reportMessages.reportedContent}
          values={{ reportedAt: new Date(createdAt).toLocaleDateString() }}
        />
        <Button
          variant="link"
          onClick={() => setHidden(!hidden)}
          className="cursor-pointer underline"
        >
          <FormattedMessage {...reportedButtonMessages[hidden ? 'showAnyway' : 'hide']} />
        </Button>
      </p>
      {children && !hidden ? <div className="mt-4 pointer-events-none">{children}</div> : null}
    </div>
  );
};
